import 'antd/lib/form/style/css';
import '@vtx/components/lib/vtx-form-layout/style/css';
import '@vtx/components/lib/vtx-datagrid/style/css';
import '@vtx/components/lib/vtx-image/style/css';
import '../../theme/global.less';
import '../../theme/default.less';
import '../../theme/dark.less';
import '../../vtx-base-modal/style/index.less';
import './index.less';
